import type { TokenInfo } from '@yoop/server-model/token-info';

/**
 * Predicate for an owned token
 * @param token
 */
export const owned = (token: TokenInfo): boolean => Boolean(token.owned);
